module.exports = __webpack_public_path__ + "img/vision.2971f6e5.png";